import React, { useState, Fragment, useEffect } from "react";
import Select from "react-select";
import Fade from "@material-ui/core/Fade";
import CircularProgress from "@material-ui/core/CircularProgress";
import { ContentTypes } from "../../../Constants/selections";
import Firebase from "../../../firebasehelper";

import {
  YOUTUBE_URL,
  IMAGE_UPLOAD,
  VIDEO_UPLOAD,
  GIF_UPLOAD,
} from "../../../Constants/types";
import { UPLOADING_VIDEO, UPLOADING_IMAGE } from "../../../Constants/string";

import ImageUpload from "../../../components/ContentUpload/ImageUpload";
import VideoUpload from "../../../components/ContentUpload/VideoUpload";
import YoutubeInput from "../../../components/ContentUpload/YoutubeInput";

const Styles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    width: 250,
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: 14,
  }),
};

const EventMedia = ({ onChangeMedia, isVisible, currentMedia = null }) => {
  const [contentType, setContentType] = useState();
  const [loading, setLoading] = useState(false);
  const [loadingScript, setLoadingScript] = useState("");
  const [mediaUrl, setMediaUrl] = useState("");

  useEffect(() => {
    if (currentMedia) {
      setMediaUrl(currentMedia.mediaUrl);
      setContentType(currentMedia.contentType);
    } else {
      setMediaUrl("");
      setContentType({});
    }
  }, [currentMedia]);

  // useEffect(() => {
  //   onChangeMedia({ mediaUrl, contentType });
  // }, [mediaUrl, contentType]);

  const uploadContent = (type) => async (mediaContent) => {
    const uploadFolder = "events";
    const title = new Date().getTime().toString();
    if (type === GIF_UPLOAD) {
      setLoading(true);
      setLoadingScript(UPLOADING_IMAGE);
      let gif_url = await Firebase.uploadGif(
        mediaContent,
        title,
        uploadFolder + "/gifs"
      );
      setMediaUrl(gif_url);
      onChangeMedia({ mediaUrl: gif_url, contentType });
      setLoading(false);
    } else if (type === IMAGE_UPLOAD) {
      setLoading(true);
      setLoadingScript(UPLOADING_IMAGE);
      let img_url = await Firebase.uploadImage(
        mediaContent,
        title,
        uploadFolder + "/images"
      );
      setMediaUrl(img_url);
      onChangeMedia({ mediaUrl: img_url, contentType });
      setLoading(false);
    } else if (type === VIDEO_UPLOAD) {
      setLoading(true);
      setLoadingScript(UPLOADING_VIDEO);
      const uploadTask = Firebase.uploadVideo(
        mediaContent,
        uploadFolder + "/videos"
      );
      uploadTask.on(
        "state_changed",
        handleUploadProgress,
        handleUploadError,
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            setMediaUrl(downloadURL);
            onChangeMedia({ mediaUrl: downloadURL, contentType });
            setLoadingScript("");
            setLoading(false);
          });
        }
      );
    } else if (type === YOUTUBE_URL) {
      setMediaUrl(mediaContent);
      onChangeMedia({ mediaUrl: mediaContent, contentType });
    }
  };

  const handleUploadProgress = (snapshot) => {
    var progress = (
      (snapshot.bytesTransferred / snapshot.totalBytes) *
      100
    ).toFixed(0);
    const loading_script = UPLOADING_VIDEO + " " + progress + "%";
    setLoadingScript(loading_script);
  };

  const handleUploadError = (error) => {
    setLoading(false);
    setLoadingScript("");
  };

  return (
    <div className={`content-tags ${!isVisible ? "d-none" : ""} mt-3`}>
      <p className="add-event-title">Media</p>
      <div className="form-group">
        <Select
          value={contentType}
          onChange={(t) => {
            setContentType(t);
            onChangeMedia({ contentType: t, mediaUrl: "" });
          }}
          options={ContentTypes}
          styles={Styles}
          placeholder="Media Type"
        />
      </div>
      {contentType && (
        <div className="input-container mb-2">
          {contentType.value === YOUTUBE_URL && (
            <YoutubeInput
              onChangeContent={uploadContent(YOUTUBE_URL)}
              currentUrl={mediaUrl}
            />
          )}
          {contentType.value === IMAGE_UPLOAD && (
            <ImageUpload
              onChangeContent={uploadContent(IMAGE_UPLOAD)}
              contentUrl={mediaUrl}
            />
          )}
          {contentType.value === GIF_UPLOAD && (
            <ImageUpload
              isGif={true}
              onChangeContent={uploadContent(GIF_UPLOAD)}
              contentUrl={mediaUrl}
            />
          )}
          {contentType.value === VIDEO_UPLOAD && (
            <VideoUpload
              onChangeContent={uploadContent(VIDEO_UPLOAD)}
              defaultVideo={mediaUrl}
            />
          )}
        </div>
      )}
      <Fade
        in={loading}
        style={{
          transitionDelay: loading ? "800ms" : "0ms",
        }}
        unmountOnExit
      >
        <Fragment>
          <p>{loadingScript}</p>
          <CircularProgress />
        </Fragment>
      </Fade>
    </div>
  );
};

export default EventMedia;



// WEBPACK FOOTER //
// ./src/screens/Event/components/EventMedia.js